<template>
<div class="container-fluid" id="dashboard_wrap">

	<ForumList category="latest" />

</div>
</template>


<script>
import ForumList from '../../components/forum/ForumList.vue';
export default {
	name: "Dashboard",
	components:{ 
		ForumList
	},
	props: {
	},
	data() {
		return {
		}
	},
	computed:{
	},
	methods:{
	},
	mounted() {
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
